export class LsUtil {
  static setLS(key, obj) {
    try {
      localStorage.setItem(key, JSON.stringify(obj));
    } catch (err) {

    }
  }

  static removeLS(key) {
    try {
      localStorage.removeItem(key);
    } catch (err) {

    }
  }

  static getLS(keyName) {
    let rtnValue = '';
    try {
      rtnValue = localStorage.getItem(keyName);
    } catch (err) {
      rtnValue = '';
    }
    return rtnValue;
  }

  static getLSAsObj(keyName) {
    let rtnValue = null;
    try {
      rtnValue = JSON.parse(LsUtil.getLS(keyName));
    } catch (err) {
      rtnValue = null;
    }
    return rtnValue;
  }
}
